module.exports = {"data":{"contributionsJson":{"name":"modern","www_url":"http://i-love-u.ch","thema":"modern","issue_month":"April","issue_year":2008,"issue_date":200804,"artist":"miriam","location":"Slowakei","email":"miriam.simkova@gmail.com","id":"contribution_359","media_type":"textz","position_in_section":2,"media_uri":"media/2008/April/textz/modern2.jpg","media_th_uri":"media/2008/April/textz/tn_modern2.jpg","still_image_count":4,"moving_image_count":1,"textz_count":9,"soundz_count":0}},"pathContext":{"id":"contribution_359"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200804-textz-2.json
// module id = 1018
// module chunks = 123677980770067